// 在http.js中引入axios
import { Message } from 'element-ui'
import axios from 'axios' // 引入axios

import QS from 'qs' // 引入qs模块，用来序列化post类型的数据，后面会提到
import router from '../router/index'
// vant的toast提示框组件，大家可根据自己的ui组件更改。
// import { Toast } from 'vant';

// 环境的切换
// axios.defaults.baseURL = 'https';
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/'
} else if (process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = window.location.protocol + '//' + window.location.host
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = window.location.protocol + '//' + window.location.host
}
axios.defaults.timeout = 10000

// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// import store from '@/store/index';

// axios.defaults.withCredentials = false;
axios.defaults.withCredentials = true
// 请求拦截器15288674
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = localStorage.getItem('token');
    // const cookie = localStorage.getItem('cookie');
    // config.headers['Cookie'] = 'bbbbbbbbbbb';
    config.headers.post['Content-Type'] = 'multipart/form-data;'
    config.headers.post['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    config.headers.get['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    config.headers.put['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return config
  },
  error => {
    return Promise.error(error)
  })

// 响应拦截器
// axios.interceptors.response.use(
//     response => {
//         // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
//         // 否则的话抛出错误
//         if (response.status === 200) {
//             return Promise.resolve(response);
//         } else {
//             return Promise.reject(response);
//         }
//     },
//     // 服务器状态码不是2开头的的情况
//     // 这里可以跟你们的后台开发人员协商好统一的错误状态码
//     // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
//     // 下面列举几个常见的操作，其他需求可自行扩展
//     error => {

//       // window.open("http://www.baidu.com");
//       // console.log(error.response);

//         if (error.response.status) {
//             switch (error.response.status) {
//                 // 401: 未登录
//                 // 未登录则跳转登录页面，并携带当前页面的路径
//                 // 在登录成功后返回当前页面，这一步需要在登录页操作。
//                 case 401:
//                     window.open("https://erp.knoya.com");
//                     // router.replace({
//                     //     path: '/login',
//                     // });
//                     break;

//                 // 403 token过期
//                 // 登录过期对用户进行提示
//                 // 清除本地token和清空vuex中token对象
//                 // 跳转登录页面
//                 case 403:
//                 console.log();
//                     if(error.response.statusText.indexOf("Access denied for user") != -1 ){
//                       Message({message:'没有权限',type:'error',duration:2000});
//                       break;
//                     }
//                     Message({message:'登录过期，请重新登录',type:'error',duration:2000});
//                     window.open("https://erp.knoya.com");
//                     // router.replace({
//                     //     path: '/login',
//                     // });
//                     break;
//                 // 404请求不存在
//                 case 404:
//                     Message({message:'网络请求不存在',type:'error',duration:2000});
//                     break;
//                 case 406:
//                     Message({message:error.response.data,type:'error',duration:2000});
//                     break;
//                 // 其他错误，直接抛出错误提示
//                 default:
//                     Message({message:'error.response.data.message',type:'error',duration:2000});
//             }
//             return Promise.reject(error.response);
//         }
//     }
// );

export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      let data = res.data
      let status = res.status
      if (status !== 200) {
        status = data.status
        Message({message: '请求异常', type: 'error', duration: 2000})
        return
      }
      status = data.code
      if (status !== 0) {
        if (status === 401) {
          window.top.location = 'https://erp.knoya.com/'
          // window.top.location = window.location.protocol + '//' + window.location.host + window.location.pathname + '#/jlb_login';
          return
        }

        data.ok = false
        resolve(data)
        Message({message: data.message, type: 'error', duration: 2000})
      } else {
        data.ok = true
        resolve(data)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

export function get1 (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      let data = res.data
      let status = res.status
      if (status !== 200) {
        status = data.status
        Message({message: '请求异常', type: 'error', duration: 2000})
        return
      }
      status = data.code
      if (status !== 0) {
        data.ok = false
        resolve(data)
        Message({message: data.message, type: 'error', duration: 2000})
      } else {
        data.ok = true
        resolve(data)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

export function download (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
      responseType: 'blob'
    }).then(res => {
      let data = res.data
      resolve(data)
    }).catch(err => {
      reject(err)
    })
  })
}

export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        let data = res.data
        let status = res.status
        if (status !== 200) {
          status = data.status
          Message({message: '请求异常', type: 'error', duration: 2000})
          return
        }
        status = data.code
        if (status !== 0) {
          if (status === 401) {
            window.top.location = 'https://erp.knoya.com/'
            // window.top.location = window.location.protocol + '//' + window.location.host + window.location.pathname + '#/jlb_login';
            return
          }

          data.ok = false
          resolve(data)
          Message({message: data.message, type: 'error', duration: 2000})
        } else {
          data.ok = true
          resolve(data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function postimg (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        console.log(res.data)
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function puts (url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(res => {
        let data = res.data
        let status = res.status
        if (status !== 200) {
          status = data.status
          Message({message: '请求异常', type: 'error', duration: 2000})
          return
        }
        status = data.code
        if (status !== 0) {
          if (status === 401) {
            window.top.location = 'https://erp.knoya.com/'
            // window.top.location = window.location.protocol + '//' + window.location.host + window.location.pathname + '#/jlb_login';
            return
          }

          data.ok = false
          resolve(data)
          Message({message: data.message, type: 'error', duration: 2000})
        } else {
          data.ok = true
          resolve(data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/request/http.js